"use strict";

function copyLink() {
  $('.js-copy').on("click", function () {
    var value = $(this).data('url'),
        domain = $(this).data('domain');
    var $temp = $("<input>");
    $('body').append($temp);

    if (domain) {
      $temp.val(domain + value).select();
    } else {
      $temp.val(value).select();
    }

    document.execCommand("copy"); // Notification

    $('.js-notification-link').addClass('show');
    setTimeout(function () {
      $('.js-notification-link').removeClass('show');
    }, 3000);
    $temp.remove();
  });
}

copyLink();